export default {
  state: {
    token: sessionStorage.getItem('token') || '',
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {}
  },
  mutations: {
    setUserInfo (state) {
      state.userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {}
    },
    setToken (state) {
      state.token = sessionStorage.getItem('token') || ''
    }
  },
  actions: {
  }
}
